import {
    addApmLocationInfo,
    deleteApmLocationInfo,
    fetchApmLocationInfo,
    updateApmLocationInfo,
} from '../../../../../actions/collections/apmLocationInfo';
import { fetchLocationInfoTitles } from '../../../../../actions/locationInfoValues';
import createItemHOC from '../../../../createItemHOC';
import ItemForm from './InfoForm';

function mapStateToProps({ apmLocationInfo, locationInfoValues }) {
    return {
        items: apmLocationInfo.collection,
        preItems: {
            locationInfoFields: locationInfoValues.fields,
            locationInfoTitles: locationInfoValues.titles,
        },
    };
}

export default createItemHOC({
    actions: {
        addItem: addApmLocationInfo,
        deleteItem: deleteApmLocationInfo,
        fetchItem: fetchApmLocationInfo,
        updateItem: updateApmLocationInfo,
    },
    fetchParamsKeys: ['apmId'],
    fetchPreActions: { fetchLocationInfoTitles },
    fetchPreActionsProps: {
        fetchLocationInfoTitles: ({ params }) => ({ excludeApmId: params.apmId }),
    },
    ItemForm,
    mapStateToProps,
    permissions: {
        create: 'apm_location_info_create',
        delete: 'apm_location_info_delete',
        read: 'apm_location_info_read',
        update: 'apm_location_info_update',
    },
});
